import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store'
import setupDirective from './lib/directive/directive';
import VueVideoPlayer from '@videojs-player/vue'
import i18n from './i18n/i18n.js';
import VConsole from 'vconsole';
import VueLazyload from 'vue-lazyload'
import '@varlet/touch-emulator'
import { isDev } from '@/utils/tools.js';
import '@/assets/css/css.js'
const pinia = createPinia();
const app = createApp(App)

//import 'core-js/stable';
//import 'regenerator-runtime/runtime';
//import 'core-js/features/global-this';

app.use(pinia)

setupDirective(app)
app.use(router)
app.use(store)
app.use(VueVideoPlayer)
app.use(i18n)
app.use(VueLazyload)

app.mount('#app')
if(isDev()){
   window.__vConsole = new VConsole({ theme: 'dark' });
}
